'use strict';
/**
 * Dependencies
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var crypto = require('@trust/webcrypto');
var NotSupportedError = require('./errors/NotSupportedError');

var _require = require('@trust/jwa'),
    JWA = _require.JWA;

/**
 * KeyManagement
 */


var KeyManagement = function () {

  /**
   * constructor
   */
  function KeyManagement() {
    _classCallCheck(this, KeyManagement);

    // Entries for key algorithms used to decide on
    // cek and compute the encrypted key
    this.keyAlgorithms = new Map([['dir', { encrypt: this.direct, decrypt: this.direct }]]);
  }

  _createClass(KeyManagement, [{
    key: 'direct',
    value: function direct(alg, key) {
      return {
        cek: key,
        encrypted_key: new Uint8Array()
      };
    }
  }, {
    key: 'keyWrapOrEncrypt',
    value: function keyWrapOrEncrypt(alg, key) {
      var cek = void 0,
          encrypted_key = void 0;
      cek = new Uint8Array(this.keyAlgorithms.get(alg).cekLength);
      cek = crypto.getRandomValues(cek);
      JWA.encryptKey(alg, cek, key).then(function (result) {
        encrypted_key = result;

        return {
          cek: cek,
          encrypted_key: encrypted_key
        };
      });
    }
  }, {
    key: 'keyAgreeAndWrap',
    value: function keyAgreeAndWrap(alg, key) {
      var cek = new Uint8Array(this.keyAlgorithms.get(alg).cekLength);
      cek = crypto.getRandomValues(cek);
      // use alg to agree on the key
      JWA.generateKey(alg).then(function (agreedKey) {
        JWA.encryptKey(alg, cek, agreedKey).then(function (result) {
          encrypted_key = result;

          return {
            cek: cek,
            encrypted_key: encrypted_key
          };
        });
      });
    }
  }, {
    key: 'directAgree',
    value: function directAgree(alg, key) {
      JWA.generateKey(alg).then(function (agreedKey) {
        return {
          cek: agreedKey,
          encrypted_key: new Uint8Array()
        };
      });
    }

    /**
     * determineCek
     *
     * @description
     * Call the corresponding method for the algorithm type
     * based on JWA alg name
     *
     * @param {Boolean} verify
     * @param {Object} alg
     * @param {Object} key
     *
     * @returns {Promise}
     */

  }, {
    key: 'determineCek',
    value: function determineCek(verify, alg, key) {
      if (!this.keyAlgorithms.get(alg)) {
        throw new NotSupportedError("Key Algorithm is not supported");
      }
      if (!verify) {
        return this.keyAlgorithms.get(alg).encrypt(alg, key);
      } else {
        return this.keyAlgorithms.get(alg).decrypt(alg, key);
      }
    }
  }]);

  return KeyManagement;
}();

/**
 * Export
 */


module.exports = KeyManagement;


// WEBPACK FOOTER //
// ./lib/KeyManagement.js